"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderType = void 0;
var ProviderType;
(function (ProviderType) {
    ProviderType["StageClip"] = "StageClip";
    ProviderType["HerffJonesCollege"] = "HerffJonesCollege";
    ProviderType["HerffJonesHighSchool"] = "HerffJonesHighSchool";
    ProviderType["MarchingOrder"] = "MarchingOrder";
})(ProviderType = exports.ProviderType || (exports.ProviderType = {}));
//# sourceMappingURL=provider-type.js.map